import { Button } from '@/ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/ui/select'
import { MaterialIcon } from '@/ui/material-icon'
import styles from './Pagination.module.scss'

interface PaginationProps {
  currentPage: number
  totalPages: number
  totalRecords?: number
  rowsPerPage: number
  onPageChange: (page: number) => void
  onRowsPerPageChange: (rowsPerPage: number) => void
  pageSizeOptions?: number[]
}

export default function Pagination({
  currentPage,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  pageSizeOptions = [10, 20, 50, 100],
}: PaginationProps) {
  return (
    <div className={styles.paginationBar}>
      {/* 🔹 Left Section */}
      <div className={styles.left}>
        <span className={styles.label}>Rows per page</span>

        <Select
          value={String(rowsPerPage)}
          onValueChange={(v) => onRowsPerPageChange(Number(v))}
        >
          <SelectTrigger className={styles.rowsSelect}>
            <SelectValue placeholder={String(rowsPerPage)} />
          </SelectTrigger>

          <SelectContent>
            {pageSizeOptions.map((opt) => (
              <SelectItem key={opt} value={String(opt)}>
                {opt}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* 🔹 Right Section */}
      <div className={styles.right}>
        <span className={styles.pageText}>
          {`Page ${currentPage} of ${totalPages}`}
        </span>

        <div className={styles.controls}>
          <Button
          
            variant="outline"
            size="icon"
            className={styles.navBtn}
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
            aria-label="Previous page"
          >
            <MaterialIcon name="chevron_left" size={16} />
          </Button>

          <Button
            variant="outline"
            size="icon"
            className={styles.navBtn}
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
            aria-label="Next page"
          >
            <MaterialIcon name="chevron_right" size={16} />
          </Button>
        </div>
      </div>
    </div>
  )
}